import { cdn } from "constants/common";
import { usePermissions } from "layouts/Admin";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { userSelector } from "slices/userSlice";
const QuotationsTable = ({ item, onReject, onApprove, onView }) => {
  const { checkPermission } = usePermissions();
  const { user } = useSelector(userSelector);
  const role = user?.role ?? user?.user?.role;

  const formattedDate = moment(item?.created_at).format(
    "MMM D, YYYY HH:mm:ss"
  );

  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">
          <tr>
            <th className="col-3">Quotations</th>
            <th className="col-2">Version</th>
            <th className="col-3">Notes</th>
            <th className="col-2">Date</th>
            <th className="col-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(item?.quotations) &&
            item.quotations.map((quotation, qIdx) => (
              <tr key={qIdx}>
                <td className="col-3">
                  {role === "subuser"
                    ? checkPermission("Download Quotations")
                      ? quotation?.pdf_path
                        ? (
                            <a
                              href={cdn + quotation.pdf_path}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Download Quotation
                            </a>
                          )
                        : "N/A"
                      : quotation?.pdf_path
                      ? "Download Quotation"
                      : "N/A"
                    : // non-subuser: always allow download link when present
                    quotation?.pdf_path ? (
                      <a href={cdn + quotation.pdf_path} target="_blank" rel="noopener noreferrer">Download Quotation</a>
                    ) : (
                      "N/A"
                    )}
                </td>
                <td className="col-2">{quotation?.version ?? "N/A"}</td>
                <td className="col-3">{quotation?.notes ?? ""}</td>
                <td className="col-2">
                  {quotation?.created_at
                    ? formattedDate
                    : "N/A"}
                </td>
                <td className="col-2" >
                  <div className="row_check">
                    {(role === "subuser" ? checkPermission('Detail Quotations') : true) && (
                      <div className='eye_area'>
                        <div className="cursor-pointer" onClick={() => onView(quotation?.id)} ><i className="fa-solid fa-eye"></i></div>
                      </div>
                    )}
                    {(["Quote Sent", 'Quote Revised'].includes(item?.status) && qIdx === 0) && <>
                    {(role === "subuser" ? checkPermission('Approve Quotations') : true) && (
                      <button className="main_button seagreen" onClick={() => onApprove(quotation?.id)}>
                        Approve
                      </button>
                    )}
                    {(role === "subuser" ? checkPermission('Reject Quotations') : true) && (
                      <button className="table_delete btn-sm" onClick={() => onReject(quotation?.id)}>Reject</button>
                    )}
                    </>}

                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default QuotationsTable;
